module.exports = __webpack_public_path__ + "static/signals-48dc1d0c52938fd772e2c5277641b0f4.wav";